var map = {
	"./amanda.jpeg": 35,
	"./bruno.jpeg": 36,
	"./calebe.jpeg": 37,
	"./indiara.jpeg": 38,
	"./isaque.jpeg": 39,
	"./joao.jpg": 40,
	"./luciana.jpeg": 41,
	"./luciana.jpg": 42,
	"./martha.jpeg": 43,
	"./martha.jpg": 44,
	"./vitor.jpeg": 45
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 168;